import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { useFormikContext } from "formik";
import { CardGroup, radioKeyboardEventHandler } from "@qgiv/core-donor";
import ConnectedClassificationCard from "./ConnectedClassificationCard";

const Classifications = ({
    classifications = [],
    sectionHeading,
    additionalText = "",
    controlId,
    unsetSelectedClassification,
    updateRegistration = () => {},
    registrations = [],
    setUnsetSelectedClassification = () => {},
    dispatch = () => {},
}) => {
    const {
        values: { Classification = [] },
        setFieldValue,
        setFieldTouched,
    } = useFormikContext();

    const classificationRefs = classifications.map(() => React.createRef());

    const handleKeyDown = (event, index) => {
        if (Classification.length > 0) return;
        radioKeyboardEventHandler(event, index, classificationRefs);
    };

    // Outdated included Classification
    useEffect(() => {
        if (unsetSelectedClassification) {
            setFieldValue("Classification", []);
            setFieldTouched("Classification");
            // Since the classification was rejected, every registration will
            // need to be reviewed. Setting this flag will block payment page
            // form submission and display "Review Details" link under the registrations
            registrations.forEach((reg, i) => {
                dispatch(
                    updateRegistration({
                        index: i,
                        registration: {
                            Needs_To_Be_Reviewed: true,
                        },
                    }),
                );
            });
            dispatch(setUnsetSelectedClassification(false));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [unsetSelectedClassification]);

    // Because we want to maintain the focus state on a selected classification CardInput component,
    // we are not going to filter for the selected classification since it will cause a re-render of all
    // of the CardInput components, and we will lose track of the component we want to focus on. Instead
    // we are going to conditionally render the ClassificationCard.

    return (
        <>
            <h2>{sectionHeading}</h2>
            {additionalText && <p>{additionalText}</p>}
            <CardGroup legend="Choose a classification" colWidth={12}>
                {classifications.map((classification, i) => {
                    const { id } = classification;

                    const isSelectedClassification =
                        Classification.length === 1 &&
                        `${Classification[0]}` === `${id}`;

                    const displayClassificationCard =
                        Classification.length === 0 || isSelectedClassification;

                    return (
                        displayClassificationCard && (
                            // eslint-disable-next-line jsx-a11y/no-static-element-interactions
                            <div
                                key={id}
                                onKeyDown={(e) => handleKeyDown(e, i)}
                            >
                                <ConnectedClassificationCard
                                    id={id}
                                    name="Classification"
                                    type="checkbox"
                                    controlId={controlId}
                                    classificationRef={classificationRefs[i]}
                                />
                            </div>
                        )
                    );
                })}
            </CardGroup>
        </>
    );
};

Classifications.propTypes = {
    classifications: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        }),
    ),
    dispatch: PropTypes.func,
    registrations: PropTypes.arrayOf(PropTypes.shape()),
    sectionHeading: PropTypes.string.isRequired,
    additionalText: PropTypes.string,
    controlId: PropTypes.number.isRequired,
    setUnsetSelectedClassification: PropTypes.func,
    unsetSelectedClassification: PropTypes.bool.isRequired,
    updateRegistration: PropTypes.func,
};

export default Classifications;
